import { render, staticRenderFns } from "./HyroxSimulationRegistration.vue?vue&type=template&id=19cdf01b&scoped=true"
import script from "./HyroxSimulationRegistration.vue?vue&type=script&lang=js"
export * from "./HyroxSimulationRegistration.vue?vue&type=script&lang=js"
import style0 from "./HyroxSimulationRegistration.vue?vue&type=style&index=0&id=19cdf01b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cdf01b",
  null
  
)

export default component.exports